import React, { useEffect, useState } from 'react'
import { Card, CardContent, Typography, CircularProgress } from '@mui/material'
import { blue } from '@mui/material/colors'
import api from '../../../config/api'

const UserLastActivity = () => {
  const [activity, setActivity] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState('')

  // Функция для получения данных о последней активности
  const fetchActivity = async () => {
    try {
      const response = await api.get('/API_FRONT/user/activity/')
      const { last_login, last_activity } = response.data
      setActivity({
        last_login: new Date(last_login).toLocaleString('ru-RU'),
        last_activity: new Date(last_activity).toLocaleString('ru-RU'),
      })
    } catch (error) {
      console.error('Ошибка при получении активности:', error)
      setError('Не удалось загрузить данные активности')
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchActivity()
  }, [])

  return (
    <Card sx={{ backgroundColor: blue[100], mb: 2 }}>
      <CardContent>
        <Typography variant="h6">Недавняя активность</Typography>
        {loading ? (
          <CircularProgress />
        ) : error ? (
          <Typography variant="body1" color="error">
            {error}
          </Typography>
        ) : (
          <>
            <Typography variant="body1">
              Последний вход: {activity?.last_login || 'Нет данных'}
            </Typography>
          </>
        )}
      </CardContent>
    </Card>
  )
}

export default UserLastActivity
